import { LogLevel, logger } from "@layer/utils/lib/logger";

type ErrorHandlerProps = {
	error: Error | any;
	source: string;
	operation: string;
	message?: string;
};

type CreateApiErrorProps = {
	error: Error | any;
	source: string;
	status: string;
	defaultMessage: string;
};

export const getErrorMessage = (error: Error | any): string => {
	if (error?.message && typeof error.message === "string") {
		try {
			const parsed = JSON.parse(error.message);
			return parsed.message || parsed.error || error.message || "";
		} catch {
			return error?.message || "";
		}
	}
	return error?.message || "Unknown error occurred";
};

export const errorHandler = ({
	error,
	source,
	operation,
	message,
}: ErrorHandlerProps) => {
	const errorMessage = message || getErrorMessage(error);
	logger(
		{
			source,
			operation,
			message: errorMessage,
		},
		LogLevel.ERROR,
	);
};

export const createEndpointError = ({
	error,
	source,
	status,
	defaultMessage,
}: CreateApiErrorProps): string => {
	const message = getErrorMessage(error) || defaultMessage;
	return [`${source}`, `Status: ${status}`, `Message: ${message}`].join("\n");
};
